import Router from 'next/router'
import Cookie from 'cookie'
import { login, ping } from '_api/auth'
import { refreshToken } from '_server_utils/dpoinboxApi'

export const REFRESH_TOKEN = 'refresh'
export const STRAPI_TOKEN = 'strapijwt'

const auth = {
  accessToken: null,
  setAccessToken(token) {
    this.accessToken = token
  },
}

export const getAccessToken = (req) => {
  const { authorization } = req.headers
  return authorization ? authorization.split(' ')[1] : null
}

export const getRefreshToken = (req) => {
  const { cookie } = req.headers
  return cookie && Cookie.parse(cookie)[REFRESH_TOKEN]
}

export const renewRefreshToken = async (req) => {
  const refresh = getRefreshToken(req)
  return refresh ? await refreshToken({ refresh }) : null
}

export const isAuthenticated = async (req) => {
  if (typeof window !== 'undefined') {
    return auth.accessToken ? (await ping()).status === 200 : false
  } else {
    return (await renewRefreshToken(req))?.status === 200
  }
}

export const redirectTo = (destination, { res, status } = {}) => {
  typeof window !== 'undefined'
    ? Router.push(destination)
    : res.writeHead(status || 302, { Location: destination }).end()
}

export const loginUser = async ({ email, password, updateCurrentUser }) => {
  const result = await login({ email, password })
  if (result.error) {
    Promise.reject(result.error)
  }
  updateCurrentUser(result.user)
  return Promise.resolve(result)
}

export default auth
